var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"membership-benefits-list"},_vm._l((_vm.benefits),function(ref,i){
var iconUrl = ref.iconUrl;
var benefitText = ref.benefitText;
return _c('MembershipBenefitsListItem',{key:("benefits-list-item_" + i),staticClass:"membership-benefits-list__item",attrs:{"icon-url":iconUrl,"text":benefitText}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f832d0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/store/subscription/benefits-panel/TheMembershipBenefitsList.vue
// module id = null
// module chunks = 